import { render, staticRenderFns } from "./XLSXFieldMapper.vue?vue&type=template&id=72823c20&"
import script from "./XLSXFieldMapper.vue?vue&type=script&lang=js&"
export * from "./XLSXFieldMapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports